import React from 'react'
import { LucideIcon } from 'lucide-react'

export interface BaseStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: React.ReactNode
  className?: string
  iconClassName?: string
  iconContainerClassName?: string
}

export function BaseState({ 
  icon: Icon, 
  title, 
  description, 
  action,
  className = '',
  iconClassName = 'text-gray-500',
  iconContainerClassName = 'bg-gray-100 dark:bg-gray-800'
}: BaseStateProps) {
  return (
    <div className={`flex justify-center ${className}`}>
      <div className="px-4 py-12 text-left max-w-md">
        <div className={`w-[52px] h-[52px] ${iconContainerClassName} rounded-md flex items-center justify-center mb-4`}>
          <Icon className={`h-6 w-6 ${iconClassName}`} />
        </div>
        <h3 className="text-xl font-bold text-foreground mb-1">
          {title}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          {description}
        </p>
        {action}
      </div>
    </div>
  )
}
